
import { Box, Divider } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import { useFormContext, Controller } from "react-hook-form";
import { useTranslate } from "src/locales";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import ByzTitleAndInputBox from "src/components/core-components/ByzTitleAndInputBox/ByzTitleAndInputBox";

export const ParentAndPatientInfoSection = () => {
  const { t } = useTranslate();
  const { control } = useFormContext();

  return (
    <Box
      sx={{
        border: "1px solid #DBDBDB",
        borderRadius: "4px",
        padding: "20px",
        width: "100%",
        marginTop: "20px",
      }}
    >
      <Grid
        sx={{
          backgroundColor: "#63B4FF33",
          color: "#2979C3",
          borderRadius: "10px",
        }}
      >
        <ByzMuiTypography isTitle paddingRight={"20px"} paddingTop={"5px"}>
          {t("adult-patient-assessment.patient-info")}
        </ByzMuiTypography>
      </Grid>

      <Grid container spacing={2} pt={1}>
        <Grid md={2} xs={6}>
          <ByzTitleAndInputBox
            marginLeft="0px"
            title={t("child-patient-assessment.mother-full-name")}
          >
            <Controller
              name="parentInfo.motherFullName"
              control={control}
              render={({ field }) => (
                <ByzMuiTextField {...field} sx={{ pt: 1 }} />
              )}
            />
          </ByzTitleAndInputBox>
        </Grid>
        <Grid md={2} xs={6}>
          <ByzTitleAndInputBox
            marginLeft="0px"
            title={t("child-patient-assessment.mother-identity-number")}
          >
            <Controller
              name="parentInfo.motherIdentityNumber"
              control={control}
              render={({ field }) => (
                <ByzMuiTextField {...field} sx={{ pt: 1 }} />
              )}
            />
          </ByzTitleAndInputBox>
        </Grid>
        <Grid md={2} xs={6}>
          <ByzTitleAndInputBox
            marginLeft="0px"
            title={t("child-patient-assessment.father-full-name")}
          >
            <Controller
              name="parentInfo.fatherFullName"
              control={control}
              render={({ field }) => (
                <ByzMuiTextField {...field} sx={{ pt: 1 }} />
              )}
            />
          </ByzTitleAndInputBox>
        </Grid>
        <Grid md={3} xs={6}>
          <ByzTitleAndInputBox
            marginLeft="0px"
            title={t("child-patient-assessment.father-identity-number")}
          >
            <Controller
              name="parentInfo.fatherIdentityNumber"
              control={control}
              render={({ field }) => (
                <ByzMuiTextField {...field} sx={{ pt: 1 }} />
              )}
            />
          </ByzTitleAndInputBox>
        </Grid>
        <Grid md={3} xs={6}>
          <ByzTitleAndInputBox
            marginLeft="0px"
            title={t("child-patient-assessment.mother-education-level")}
          >
            <Controller
              name="parentInfo.motherEducationLevel"
              control={control}
              render={({ field }) => (
                <ByzMuiSelect
                  {...field}
                  options={[]}
                  label={t("open-process-menu.select", "capitalize")}
                  sx={{ pt: 1 }}
                />
              )}
            />
          </ByzTitleAndInputBox>
        </Grid>
      </Grid>

      <Divider sx={{ borderColor: "black", borderBottomWidth: "2px", my: 2 }} />

      <Grid container spacing={2}>
        <Grid md={2} xs={6}>
          <ByzTitleAndInputBox
            marginLeft="0px"
            title={t("child-patient-assessment.father-education-level")}
          >
            <Controller
              name="parentInfo.fatherEducationLevel"
              control={control}
              render={({ field }) => (
                <ByzMuiSelect
                  {...field}
                  options={[]}
                  label={t("open-process-menu.select", "capitalize")}
                  sx={{ pt: 1 }}
                />
              )}
            />
          </ByzTitleAndInputBox>
        </Grid>
        <Grid md={2} xs={6}>
          <ByzTitleAndInputBox
            marginLeft="0px"
            title={t("child-patient-assessment.mother-occupation")}
          >
            <Controller
              name="parentInfo.motherOccupation"
              control={control}
              render={({ field }) => (
                <ByzMuiSelect
                  {...field}
                  options={[]}
                  label={t("open-process-menu.select", "capitalize")}
                  sx={{ pt: 1 }}
                />
              )}
            />
          </ByzTitleAndInputBox>
        </Grid>
        <Grid md={2} xs={6}>
          <ByzTitleAndInputBox
            marginLeft="0px"
            title={t("child-patient-assessment.father-occupation")}
          >
            <Controller
              name="parentInfo.fatherOccupation"
              control={control}
              render={({ field }) => (
                <ByzMuiSelect
                  {...field}
                  options={[]}
                  label={t("open-process-menu.select", "capitalize")}
                  sx={{ pt: 1 }}
                />
              )}
            />
          </ByzTitleAndInputBox>
        </Grid>
        <Grid md={3} xs={6}>
          <ByzTitleAndInputBox
            marginLeft="0px"
            title={t("child-patient-assessment.mother-habits")}
          >
            <Controller
              name="parentInfo.motherHabits"
              control={control}
              render={({ field }) => (
                <ByzMuiSelect
                  {...field}
                  options={[]}
                  label={t("open-process-menu.select", "capitalize")}
                  sx={{ pt: 1 }}
                />
              )}
            />
            <ByzTitleAndInputBox
              marginLeft="0px"
              sx={{ marginTop: "8px" }}
              title={t("description", "capitalize")}
            >
              <Controller
                name="parentInfo.motherHabitsDescription"
                control={control}
                render={({ field }) => (
                  <ByzMuiTextField {...field} multiline rows={2} sx={{ pt: 1 }} />
                )}
              />
            </ByzTitleAndInputBox>
          </ByzTitleAndInputBox>
        </Grid>
      </Grid>
    </Box >
  );
};
